import { IAdminProgramCode } from '@interfaces/adminProgramCodes';
import { IDrugClass } from '@interfaces/lookups';
import { IRiskLevel } from '@interfaces/riskLevels';

import { apiUrls } from './urls';
import { get } from './utils';

export const getAdminDrugClasses = (programCode: number) =>
  get<IDrugClass[]>(apiUrls.lookups.adminDrugClasses, { programCode });

export const getAdminRiskLevels = (programCode: number) =>
  get<IRiskLevel[]>(apiUrls.lookups.adminRiskLevels, { programCode });

export const getAdminProgramCodes = () => get<IAdminProgramCode[]>(apiUrls.lookups.programCodes);
